/**
 * @desc 保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.LogisticsAttrTypeResponseDto>;
export function request(
  body: defs.basics.LogisticsAttrTypeRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/logisticsAttrType/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
